import { createMemo } from "solid-js";

import { toast } from "@/components/Base/Toaster/Toaster";
import { GameSearchSort } from "@/enum/component";
import { gclassEnum, noEntryGameList } from "@/enum/game";
import { useI18n } from "@/i18n";
import { setCurGameId, updateGameLoaded } from "@/stores/gameStore";
import { sysConfigStore } from "@/stores/sysConfigStore";
import { userStore } from "@/stores/userStore";

import { useRouter } from "../useRouter";

export function useGame() {
  const { push, back, preCheckEnterGame } = useRouter();
  const { t } = useI18n();

  const defaultSportGameId = createMemo(() => {
    if (!sysConfigStore.initReady) {
      return 0;
    }
    return sysConfigStore.sport_config.sport_game_id;
  });

  const enterGame = async (
    gid: number,
    itemId?: string | number,
    enterType?: "def" | "det",
  ) => {
    //判断是否需要进入游戏
    if (noEntryGameList.includes(gid)) {
      toast.error(t("game.game_not_open"));
      return;
    }
    if (userStore.isLogin && enterType === "def") {
      const pass = await preCheckEnterGame({
        gid: `${gid}`,
        itemId: `${itemId || ""}`,
        // bindPointType: bindPointType,
      });
      if (!pass) {
        return;
      }
    }

    //判断是否体育游戏
    if (gid === defaultSportGameId()) {
      push(`/sports/${gid}${itemId ? `?itemId=${itemId}` : ""}`);
      return;
    }
    if (enterType === "det") {
      push(`/game-detail/${gid}${itemId ? `?itemId=${itemId}` : ""}`);
    } else {
      push(`/game/${gid}${itemId ? `?itemId=${itemId}` : ""}`);
    }
  };

  const isShowLiveStatusIcon = (gclass: number) => {
    return [
      gclassEnum.live,
      gclassEnum.original,
      gclassEnum.slots,
      gclassEnum.shows,
    ].includes(gclass || 0);
  };

  const exitGame = async () => {
    // 退出游戏时设置游戏加载状态为 false
    updateGameLoaded(false);
    setCurGameId(0, "", "", "");
    back();
  };
  // 游戏下拉列表数据
  const gameSortList = () => {
    // Todo 翻譯
    return [
      {
        value: GameSearchSort.Popular,
        label: t("home.hot"),
        translation: true,
      },
      { value: GameSearchSort.AZ, label: "A-Z", translation: false },
      { value: GameSearchSort.ZA, label: "Z-A", translation: false },
      {
        value: GameSearchSort.new,
        label: t("search.newgames"),
        translation: true,
      },
    ];
  };
  return {
    enterGame,
    exitGame,
    isShowLiveStatusIcon,
    gameSortList,
    defaultSportGameId,
  };
}
